import React, {Component} from 'react';
import {campusApi} from '../api'
import _ from 'lodash';

import edocLogo from '../assets/images/rmuti-logo.png';
import banner from '../assets/images/banner.jpg';

import LoginSession from '../stores/LoginSession';
import ErrorMessage from '../components/ErrorMessage';

import './RmutiLoginPage.css'

export default class MaintainancePage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error_message: null,
      current_campus_url: window.location.origin,
      campuses: [],
      site_setting: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCampus = this.handleChangeCampus.bind(this);
    this.shortenCampusName = this.shortenCampusName.bind(this);
  }

  componentDidMount() {
    const { current_campus_url } = this.state;
    const { campus_name } = this.props;

    var self = this;
    campusApi.get('/campus_data').then(function (response) {
      const campuses = _.get(response.data, 'data', []);
      const campus_urls = _.map(campuses, 'url');
      const site_setting = _.get(response.data, 'included.site_setting', {});

      if (_.includes(campus_urls, current_campus_url)){
        self.setState({
          campuses: campuses,
          site_setting: site_setting,
          loading: false
        });
      }else{
        const campuses = [{url: current_campus_url, name: campus_name}];
        self.setState({
          campuses: campuses,
          site_setting: site_setting,
          loading: false
        });
      } 

    }).catch(function (error) {
      const campuses = [{url: current_campus_url, name: campus_name}]
      self.setState({
        campuses: campuses,
        loading: false
      });
    });
  }

  handleChangeCampus(event){
    let value = event.target.value;
    window.location = value;
  }

  handleChange(values) {
    this.setState({
      error_message: null
    });
  }

  handleSubmit(event) {
    event.preventDefault()
    var self = this;
    LoginSession.login(this.refs.username.value, this.refs.password.value).then(()=> {
      window.location.href = '/documents/mydoc';
    }, function(error) {
      var error_message = error.response.data.errors[0];
      self.setState({error_message: error_message});
    })
  }

  shortenCampusName(name){
    let shorten_name = name.trim();
    shorten_name = shorten_name.replace('มหาวิทยาลัยเทคโนโลยีราชมงคลอีสาน', '');
    shorten_name = shorten_name.replace('วิทยาเขต','');
    shorten_name = shorten_name.trim();

    return shorten_name;
  }

  render(){
    let feedback_url = "#";
    switch(this.props.code_name) {
      case "RMUTI":
        feedback_url = "https://goo.gl/w1VYq4";
        break;
      case "RMUTI_SKC":
        feedback_url = "https://goo.gl/R6zihq";
        break;
      case "RMUTI_KKC":
        feedback_url = "https://goo.gl/bexAQj";
        break;
      case "RMUTI_SURIN":
        feedback_url = "https://goo.gl/VCM8yu";
        break;
    }

    const { current_campus_url, campuses } = this.state;
    return (
      <div id='RmutiLoginPage' className="m-3 m-md-0">
        <div className='row mt-4'>
          <div className='col-md-9 ml-auto mr-auto'>
            <h1 className='display-5 font-weight-bold text-center text-md-left' style={{color: '#999999'}}>ระบบงานสารบรรณอิเล็กทรอนิกส์</h1>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-9 ml-auto mr-auto'>
            <hr />
          </div>
        </div>
        <div className='row'>
          <div className='ml-auto col-md-2 text-md-right'>
            &ensp;
          </div>
          <div className='col-md-8'>
            <div className='row'>
              <div className='col-md-2'></div>
              <div className='col-md-9 mr-auto error_message_navigation'>
                {this.state.error_message && <ErrorMessage error_message={this.state.error_message} />}
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='ml-auto col-md-2 text-center text-md-right'>
            {(!this.state.loading && !_.isEmpty(this.state.site_setting.site_logo)) ? (
              <img alt='LOGO' src={this.state.site_setting.site_logo} className='w-100 border rmuti-logo-sm' />
            ) : (!this.state.loading && _.isEmpty(this.state.site_setting.site_logo)) ? (
              <img alt='LOGO' src={edocLogo} className='w-100 border rmuti-logo-sm' />
            ) : 'LOGO'}
          </div>
          <div className='col-md-8'>
            <form onSubmit={this.handleSubmit}>
              <div className='row form-group'>
                <div className='col-md-12'>
                  <label>ขณะนี้อยู่ระหว่างการปรับปรุงระบบ...ขออภัยในความไม่สะดวก</label>
                </div>
              </div>
            </form>
          </div>
        </div>

        <hr className='my-4' />

        <div className='row mb-4'>
          <div className='col-md-9 ml-auto mr-auto'>

            <div className='row'>
              <div className='col-5'>
                <h4 className='font-weight-bold'>ประชาสัมพันธ์</h4>

                <div>
                  <a href="https://forms.gle/tRY1rHHzvsiPCYjX6" target="_blank" rel="noopener noreferrer">
                    - แบบฟอร์มเพิ่มข้อมูลผู้ใช้งานระบบ e-Document
                  </a>
                </div>
              </div>
              <div className='col-7'>
                <a href="http://edoc-archive.rmuti.ac.th" target="_blank" rel="noopener noreferrer" style={{fontSize: "30px", color: "red"}}>
                  ค้นหาข้อมูลเอกสารจากระบบเดิม
                </a>
                
                <div>
                  <a href="https://forms.gle/7TEUJaqjKdDsu8PU8" target="_blank" rel="noopener noreferrer">
                    แบบสอบถามการใช้งานระบบสารบรรณอิเล็กทรอนิกส์ version 2
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/MaintainancePage.js